var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C13.1945 0 17 3.80545 17 8.5C17 13.1945 13.1945 17 8.5 17C3.80545 17 0 13.1945 0 8.5C0 3.80545 3.80545 0 8.5 0ZM8.5 11.05C8.27457 11.05 8.05836 11.1396 7.89896 11.299C7.73955 11.4584 7.65 11.6746 7.65 11.9C7.65 12.1254 7.73955 12.3416 7.89896 12.501C8.05836 12.6604 8.27457 12.75 8.5 12.75C8.72543 12.75 8.94163 12.6604 9.10104 12.501C9.26045 12.3416 9.35 12.1254 9.35 11.9C9.35 11.6746 9.26045 11.4584 9.10104 11.299C8.94163 11.1396 8.72543 11.05 8.5 11.05ZM8.5 3.4C8.29181 3.40003 8.09086 3.47646 7.93528 3.61481C7.7797 3.75315 7.68031 3.94379 7.65595 4.15055L7.65 4.25V9.35C7.65024 9.56665 7.7332 9.77503 7.88192 9.93256C8.03064 10.0901 8.23391 10.1849 8.45019 10.1976C8.66646 10.2103 8.87942 10.1399 9.04556 10.0009C9.21169 9.86182 9.31846 9.66458 9.34405 9.44945L9.35 9.35V4.25C9.35 4.02457 9.26045 3.80837 9.10104 3.64896C8.94163 3.48955 8.72543 3.4 8.5 3.4Z",
    fill: "#F4A261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningHovered);
export default __webpack_public_path__ + "static/media/warning-hovered.ed62727db13954ddc6c495a309b95970.svg";
export { ForwardRef as ReactComponent };